/**
 * Lets a detail screen tell the breadcrumb what a record id is called, so the
 * trail reads "Vendors / RKH_V0006 — Shree Balaji Painters" instead of the raw
 * uuid from the URL.
 */
const labels = new Map<string, string>();
const listeners = new Set<() => void>();

export function setBreadcrumbLabel(segment: string, label: string | null): void {
  if (label === null) labels.delete(segment);
  else labels.set(segment, label);
  listeners.forEach((fn) => fn());
}

export function getBreadcrumbLabel(segment: string): string | undefined {
  return labels.get(segment);
}

export function subscribeBreadcrumbLabels(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

/** Snapshot identity changes only when a label changes, so React can bail out. */
let version = 0;
const bump = (): void => { version += 1; };
listeners.add(bump);
export function breadcrumbLabelsVersion(): number {
  return version;
}
